import { render, staticRenderFns } from "./showTopicsProgressReview.vue?vue&type=template&id=4397b479&scoped=true&"
import script from "./showTopicsProgressReview.vue?vue&type=script&lang=js&"
export * from "./showTopicsProgressReview.vue?vue&type=script&lang=js&"
import style0 from "./showTopicsProgressReview.vue?vue&type=style&index=0&id=4397b479&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4397b479",
  null
  
)

export default component.exports